import { useMemo } from 'react';

import { useAdminDetails, useMasterCompany } from '../queries';

/**
 * @description This hook has built on top `useMasterCompany` and `useAdminDetails`.
 * So, you can get these by calling this hook once <BROWNGAME>.
 * This hook should be used in admin page only.
 */
export function useAdminCompanies() {
    const { data: masterCompanies } = useMasterCompany({ status: 'active' });
    const { data: adminDetails } = useAdminDetails();

    const isAllowedAllCompanies = useMemo(
        () => adminDetails?.some(adminDetail => adminDetail.sid === '*'),
        [adminDetails]
    );

    const adminCompanies = useMemo(() => {
        if (isAllowedAllCompanies) {
            return masterCompanies;
        }

        return masterCompanies?.filter(
            masterCompany =>
                !!adminDetails?.find(admin => admin.sid === masterCompany.sid)
        );
    }, [isAllowedAllCompanies, masterCompanies, adminDetails]);

    return {
        /** @description Companies that can access */
        adminCompanies,

        /** @description Current admin detail */
        adminDetails,

        /** @description All companies */
        masterCompanies,

        /** @description For checking can access all companies or not */
        isAllowedAllCompanies
    };
}
